import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import TrackersHeader from "./-components/TrackersHeader";

export const Route = createFileRoute("/_main/trackers")({
  head: () => ({
    meta: [{ title: "Reactor | Trackers" }],
  }),
  component: TrackersLayout,
});

function TrackersLayout() {
  const pageHeader = <TrackersHeader />;
  return (
    <PageLayout header={pageHeader}>
      <div className="flex h-full w-full flex-col gap-1.5">
        <Outlet />
      </div>
    </PageLayout>
  );
}
